export default __webpack_public_path__ + "static/media/icon__flag.aaa40139.svg";